/** @jsx h */
import { h, render } from 'preact'
import domready from 'domready'
import { nodelistToArray } from '../lib/nodelistToArray'
import { uuid } from '../lib/uuid'
import { VideoLoop } from './components/VideoLoop'

const rootElementClassName = 'article-video-root'

window[rootElementClassName] = window[rootElementClassName] || {}

function init () {
  const elementsArray = nodelistToArray(document.getElementsByClassName(rootElementClassName))
  elementsArray
    .filter(el => !isInitialized(el))
    .forEach(el => {
      el.id = uuid()
      window[rootElementClassName][el.id] = true

      // Extract preloaded state sent from server
      const preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'))

      // ... and render with the exact same props
      render(<VideoLoop {...preloadedState} />, el, el.firstChild)
    })
}

function isInitialized (el) {
  return el.id && window[rootElementClassName][el.id]
}

domready(init)



// WEBPACK FOOTER //
// ./src/article/client.videoLoop.js